import { CLEAR_RESERVATION } from '../actionTypes/reservationActionTypes';

export const clearReservation = () => ({ type: CLEAR_RESERVATION });
